import React from "react";
import { FormCheckProps } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import "./RadioCheckButton.scss";

// image imports

interface Props extends FormCheckProps {
  label?: string;
}

function RadioCheckButton({ label, ...restProps }: Props) {
  return (
    <>
      <div className="RadioCheckButton-main">
        <Form.Check type="radio" label={label} style={{ fontSize: 14 }} {...restProps} />
      </div>
    </>
  );
}

export default RadioCheckButton;
